import { useState } from 'react';
import axios from 'axios';
import useSWR, { Fetcher } from 'swr';

import { api } from '../../api/api';
import { SWR_KEYS } from './swrKeys';

import { CachedResult } from './interfaces';
import { Settings, SearchSettings } from '@urbaneez.art/shared';

export function useSettings(){

    const settingsFetcher: Fetcher<CachedResult<Settings>, string> = async (url: string) => {
        const settings = await api.get(url).then((response) => {
            const responseData: Settings = response.data;
            return responseData;
        });

        return {
            data: settings,
            lastUpdated: Date.now()
        }
    }

    const {
        data: settings, 
        mutate, 
        error, 
        isLoading} = useSWR<CachedResult<Settings>>(SWR_KEYS.SETTINGS, settingsFetcher);

    const [updateSearchSettingError, setUpdateSearchSettingError] = useState<string>("")
    const updateSearchSettings = async(updatedFields: SearchSettings): Promise<boolean> => {
        try{
            setUpdateSearchSettingError("");
            await api.patch(`${SWR_KEYS.SETTINGS}/search`, updatedFields);
            await mutate();
        }catch (err) {
            var error;
            if(axios.isAxiosError(err) || err instanceof Error){
                error = err;
            }
            else {
                error = new Error("An error occurred while requesting the server to update the order.")
            }
            //TODO: return hook error
            setUpdateSearchSettingError(error.message);
            throw error;
        }
        return true;
    }

    const [updateOrderSettingError, setUpdateOrderSettingError] = useState<string>("")
    const updateOrderSettings = async(updatedFields: object) => {
        try{
            setUpdateOrderSettingError("");
            await api.patch(`${SWR_KEYS.SETTINGS}/orderNumber`, updatedFields);
            await mutate();
        } catch(err){
            var error;
            if(axios.isAxiosError(err) || err instanceof Error){
                error = err;
            }
            else {
                error = new Error("An error occurred while requesting the server to update the order.")
            }
            //TODO: return hook error
            setUpdateOrderSettingError(error.message);
            throw error;
        }
    }

    return {
        settings: settings?.data,
        lastUpdated: settings?.lastUpdated,
        refresh: mutate,
        isLoading,
        error,
        updateSearchSettings,
        updateSearchError: updateSearchSettingError,
        updateOrderSettings,
        updateOrderError: updateOrderSettingError
    }
}
